/* Angry Boy — Tactical product page.
   Gallery thumbs, quantity stepper (syncs a hidden form input),
   voltage/variant toggle, and the mobile sticky add-to-cart bar.
   Nav / hamburger / scroll-reveal are handled globally by tactical.js. */
(function () {
  'use strict';

  /* ── Gallery thumbnails ─────────────────────────────── */
  var mainImg = document.getElementById('galleryMainImg');
  var thumbs = document.querySelectorAll('.gallery-thumb');
  if (mainImg && thumbs.length) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        thumbs.forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(0.96)';
        setTimeout(function () {
          // the main image carries a responsive srcset for the first paint; srcset wins over
          // src, so it must be cleared or the gallery appears stuck on the first photo
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = thumb.dataset.src;
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 200);
      });
    });
  }

  /* ── Quantity stepper (keeps hidden form input in sync) ─ */
  var qtyNum = document.getElementById('qtyNum');
  var qtyInput = document.getElementById('qtyInput');
  var minus = document.getElementById('qtyMinus');
  var plus = document.getElementById('qtyPlus');
  var qty = 1;
  function setQty(v) {
    qty = Math.min(10, Math.max(1, v));
    if (qtyNum) qtyNum.textContent = qty;
    if (qtyInput) qtyInput.value = qty;
  }
  if (minus) minus.addEventListener('click', function () { setQty(qty - 1); });
  if (plus) plus.addEventListener('click', function () { setQty(qty + 1); });

  /* ── Voltage / option toggle. Every swatch previews its photo, even
     sold-out ones, since seeing the color shouldn't require it being in
     stock. Add to Cart tracks whichever variant is actually selected. ── */
  var voltBtns = document.querySelectorAll('.volt-btn');
  var atcBtn = document.getElementById('atcBtn');
  var atcLabel = atcBtn ? atcBtn.querySelector('.atc-label') : null;
  voltBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      voltBtns.forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      var vid = this.getAttribute('data-variant-id');
      var idInput = document.getElementById('variantId');
      if (vid && idInput) idInput.value = vid;

      var available = this.getAttribute('data-available') === 'true';
      if (atcBtn) atcBtn.disabled = !available;
      var buyNow = document.getElementById('buyNowBtn');
      if (buyNow) buyNow.disabled = !available;
      if (atcLabel) atcLabel.textContent = available ? (atcBtn.getAttribute('data-label-add') || 'Add to Cart') : (atcBtn.getAttribute('data-label-soldout') || 'Sold Out');

      var variantImage = this.getAttribute('data-variant-image');
      if (variantImage && mainImg) {
        mainImg.style.opacity = '0';
        mainImg.style.transform = 'scale(0.96)';
        setTimeout(function () {
          mainImg.removeAttribute('srcset');
          mainImg.removeAttribute('sizes');
          mainImg.src = variantImage;
          mainImg.style.opacity = '1';
          mainImg.style.transform = 'scale(1)';
        }, 200);
      }
    });
  });

  /* ── Back link ──────────────────────────────────────── */
  var backLink = document.getElementById('backLink');
  if (backLink) backLink.addEventListener('click', function () { history.back(); });

  /* ── Gallery prev/next arrows (cycle through the same thumbs) ── */
  var galleryPrev = document.getElementById('galleryPrev');
  var galleryNext = document.getElementById('galleryNext');
  if ((galleryPrev || galleryNext) && thumbs.length) {
    var goToThumb = function (dir) {
      var i = Array.prototype.indexOf.call(thumbs, document.querySelector('.gallery-thumb.active'));
      var n = (i + dir + thumbs.length) % thumbs.length;
      thumbs[n].click();
    };
    if (galleryPrev) galleryPrev.addEventListener('click', function () { goToThumb(-1); });
    if (galleryNext) galleryNext.addEventListener('click', function () { goToThumb(1); });
  }

  /* ── Mobile sticky bar ──────────────────────────────── */
  var stickyBar = document.getElementById('stickyBar');
  var buyRow = document.querySelector('.buy-row');
  var stickyBtn = document.getElementById('stickyBtn');
  var productForm = document.getElementById('product-form');
  if (stickyBar && buyRow && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      stickyBar.classList.toggle('visible', !entries[0].isIntersecting);
    }).observe(buyRow);
  }
  if (stickyBtn && productForm) {
    stickyBtn.addEventListener('click', function () {
      if (productForm.requestSubmit) productForm.requestSubmit();
      else productForm.submit();
    });
  }
})();
